module.exports = __webpack_public_path__ + "media/images/icons/ic-close-small-3925c117935e1ac3553e790971163153.svg";